import dayjs from 'dayjs'

import { ProfileData } from '@/src/types/profile'
import type { TravellerDocDetail } from '@/src/types/traveller'

type BffMainUser = {
    id?: number | null
    username?: string | null
    screenName?: string | null
    mobile?: string | null
    countryCode?: string | null
    mobileVerified?: boolean | null
    emailVerified?: boolean | null
    travellerDetails?: Array<{
        id: number
        isRegistered?: boolean | null
        personalDetails?: {
            title?: string | null
            firstName?: string | null
            lastName?: string | null
            gender?: string | null
            maritalStatus?: string | null
            dateOfBirth?: string | number | null
            screenName?: string | null
        } | null
        contactInfo?: {
            emails?: Array<{ emailId?: string | null}> | null
            addresses?: Array<{
                streetAddress?: string | null
                city?: string | null
                state?: string | null
                pincode?: string | number | null
                country?: string | null
            }> | null
        } | null
        docDetails?: Array<Partial<TravellerDocDetail>> | null
    }> | null
}

export type BffAccountUserResponse = {
    MAIN?: BffMainUser | null
    LINKED?: BffMainUser | null
}

export function transformProfileResponse(raw: BffAccountUserResponse): ProfileData {
    const main = raw?.MAIN || {}

    const countryCode = (main.countryCode || '').replace(/^\+/, '')
    const registeredTraveller = main.travellerDetails?.find(item => item?.isRegistered) || main.travellerDetails?.[0]
    const personalDetails = registeredTraveller?.personalDetails
    const primaryAddress = registeredTraveller?.contactInfo?.addresses?.[0]

    const line1 = primaryAddress?.streetAddress ?? ''
    const city = primaryAddress?.city ?? ''
    const state = primaryAddress?.state ?? ''
    const postalCode = primaryAddress?.pincode != null ? String(primaryAddress.pincode) : ''
    const country = primaryAddress?.country ?? ''
    const addressLabel = [line1, city, state, postalCode, country].filter(Boolean).join(', ')
    const rawDateOfBirth = personalDetails?.dateOfBirth
    const dateOfBirth = rawDateOfBirth && dayjs(rawDateOfBirth).isValid() ? dayjs(rawDateOfBirth).format('YYYY-MM-DD') : ''

    return {
        title: personalDetails?.title ?? '',
        firstName: personalDetails?.firstName ?? '',
        lastName: personalDetails?.lastName ?? '',
        gender: personalDetails?.gender ?? '',
        maritalStatus: personalDetails?.maritalStatus ?? '',
        email: main.username || '',
        phone: {
            countryCode,
            number: main.mobile || ''
        },
        screenName: main.screenName || personalDetails?.screenName || '',
        dateOfBirth,
        address: {
            line1,
            city,
            state,
            postalCode,
            country
        },
        addressLabel,
        photoFilePath: null
    }
}
